import { outdent } from 'outdent';
import type { DevCenterComponent } from '../../../dev-center/components/dev-center-component.js';

const CUSTOM_ELEMENT_HMR_PARAMETER = 'custom-element-hmr';
export const CUSTOM_ELEMENT_HMR_RE = new RegExp(
  `[?&]${CUSTOM_ELEMENT_HMR_PARAMETER}=([^&]+)`
);
// We need full url to localhost because of "The base URL is about:blank because import() is called from a CORS-cross-origin script." error
export const getCustomElementPathWithHMR = (
  base: string,
  component: DevCenterComponent<'SitePlugin' | 'CustomElement'>
) =>
  new URL(
    `${component.relativePath}?${CUSTOM_ELEMENT_HMR_PARAMETER}=${component.tagName}`,
    base
  ).toString();

export const getCustomElementHMRTemplate = (id: string, root: string) => {
  const originalId = id.replace(root, '');
  const originalCustomElementPath = originalId.replace(
    CUSTOM_ELEMENT_HMR_RE,
    ''
  );
  const tagName = CUSTOM_ELEMENT_HMR_RE.exec(originalId)?.at(1);

  return outdent`
    import { applyCustomElementHmr } from '@wix/cli-app/internal/component-hmr-wrapper';
    import OriginalCustomElement from '${originalCustomElementPath}';

    if (import.meta.hot) {
      import.meta.hot.accept((_)=>{})
      import.meta.hot.accept(
        '${originalId}',
        function({ default: NewCustomElement }) {
          document.querySelectorAll('${tagName}').forEach(node => {
            if (node.disconnectedCallback) {
              node.disconnectedCallback();
            }
            applyCustomElementHmr(node, NewCustomElement);
            if (node.connectedCallback) {
              node.connectedCallback();
            }
          });
        }
      );
    }

    export default OriginalCustomElement;
  `;
};
